<script setup>
const duration = 500

// Reactive state
const progress = ref(0)
const isVisible = ref(true)
const isExiting = ref(false)

let progressInterval = null

// Methods
const updateProgress = () => {
  const increment = Math.random() * 10 + 5
  progress.value = Math.min(progress.value + increment, 100)

  if (progress.value >= 100) {
    clearInterval(progressInterval)

    setTimeout(() => {
      hide()
    }, 300)
  }
}

const hide = () => {
  isExiting.value = true
  setTimeout(() => {
    isVisible.value = false
  }, 400)

  if (progressInterval) {
    clearInterval(progressInterval)
  }
}

const startProgress = () => {
  if (progressInterval) {
    clearInterval(progressInterval)
  }

  const interval = (duration / 100) * Math.random() * 0.5 + 0.5
  progressInterval = setInterval(updateProgress, interval)
}

// Lifecycle
onMounted(() => {
  startProgress()
})

onUnmounted(() => {
  if (progressInterval) {
    clearInterval(progressInterval)
  }
})
</script>

<template>
  <Transition name="loader">
    <div
      v-if="isVisible"
      class="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
      :class="{ 'animate-fade-out': isExiting }"
    >
      <div class="relative flex flex-col items-center space-y-12">
        <!-- Logo -->
        <NuxtImg
          src="/images/logo-lg-white.webp"
          width="180"
          alt="Eleven Spectacles brand logo"
          aria-label="Eleven Spectacles brand logo"
        />

        <!-- Loading Indicator -->
        <div class="flex flex-col items-center space-y-6">
          <!-- Progress Section -->
          <div class="flex flex-col items-center space-y-3">
            <!-- Progress Bar -->
            <div class="w-64 h-0.5 bg-stone-200 rounded-full overflow-hidden">
              <div
                class="h-full bg-stone-900 rounded-full transition-all duration-300 ease-out"
                :style="{ width: progress + '%' }"
              ></div>
            </div>

            <!-- Progress Text -->
            <div class="text-xs font-medium text-stone-600 tracking-wider">
              {{ Math.round(progress) }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
/* Custom animations */
@keyframes fade-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(1.02);
  }
}

.animate-fade-out {
  animation: fade-out 0.4s ease-out forwards;
}

/* Custom spinner animation */
@keyframes spin-smooth {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
